import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import find from 'lodash/find';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames/bind';
import currencyFormatter from 'currency-formatter';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import RadioButton from 'yoda-core-components/lib/components/RadioButton'; // Build failed due to old design token
import {
    paymentMethod,
    REWARD_CATEGORY,
    PROMOFINANCE_OPTION_TYPE,
    REWARD_OPTION_TYPE,
    CURRENCY_US,
} from 'yoda-checkout-components/lib//common/Constants';
import openModelEvent from 'yoda-site-components/lib/actions/AnalyticsAction';
import { getFormattedValue } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import {
    REWARD_OR_SPECIAL_FINACING_DESC,
    REWARD_OR_PROMO_FINANCING_TITLE,
    CONTINUE,
} from 'yoda-checkout-components/lib/common/LabelConstants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './PromoFinanceDecisionModal.css';
import * as cartActions from '../../actions/GetCartDetailsAction';
import * as actions from '../../actions/PaymentAction';

const cx = classNames.bind(styles);

export class PromoFinanceDecisionModal extends Component {
    static propTypes = {
        openModal: PropTypes.bool,
        orderInfo: PropTypes.arrayOf(PropTypes.object),
        orderDetails: PropTypes.arrayOf(PropTypes.object),
        orderPaymentInfo: PropTypes.arrayOf(PropTypes.object),
        actions: PropTypes.objectOf(PropTypes.func),
        currency: PropTypes.string,
        preferences: PropTypes.arrayOf(PropTypes.object),
        messagesTexts: PropTypes.arrayOf(PropTypes.object),
        deviceType: PropTypes.arrayOf(PropTypes.object),
    };

    static defaultProps = {
        openModal: false,
        orderPaymentInfo: [],
        orderInfo: [],
        orderDetails: {},
        actions: {},
        preferences: {},
        currency: CURRENCY_US,
        messagesTexts: {},
        deviceType: {},
    };

    constructor(props) {
        super();
        const selectedOffer = get(props, 'orderInfo.financing');

        this.state = {
            isModalOpen: props.openModal,
            isRewardOptionSelected: false,
            selectedOfferId: get(selectedOffer, 'id', ''),
        };
        this.handleContinueClick = this.handleContinueClick.bind(this);
        this.renderModalContent = this.renderModalContent.bind(this);
    }

    componentDidMount() {
        const {
            messagesTexts: { PROMOFINANCE_ANALYTICS },
        } = this.props;
        const analyticsEventName = PROMOFINANCE_ANALYTICS && PROMOFINANCE_ANALYTICS.promoAccepted;
        this.props.actions.openModelEvent({ name: analyticsEventName });
    }

    handleSpecialDiscountSelection = () => {
        this.setState({
            isRewardOptionSelected: true,
            selectedOfferId: '',
        });
    };

    handleFinancingOfferSelection = (financing) => {
        this.setState({
            isRewardOptionSelected: false,
            selectedOfferId: financing.id,
        });
    };

    /* istanbul ignore next */
    handleContinueClick() {
        let payload = {};
        if (this.state.selectedOfferId) {
            const { preferences } = this.props;
            const financingEligibleCardTypes = preferences.financingEligibleCardTypes || [];
            const payment = find(this.props.orderPaymentInfo, {
                paymentMethod: paymentMethod.CREDITCARD,
            });
            const cardType = payment && payment.type ? payment.type.toUpperCase() : '';
            const paymentId = payment ? payment.id : '';
            const rewardSelected = this.getRewardSelected(this.props.orderDetails);

            if (paymentId && financingEligibleCardTypes.indexOf(cardType) >= 0) {
                const promoPayload = {
                    creditCardId: paymentId,
                    id: this.state.selectedOfferId,
                };
                payload = {
                    params: {
                        data: [
                            {
                                optionType: PROMOFINANCE_OPTION_TYPE,
                                promoFinance: promoPayload,
                            },
                        ],
                    },
                    rewardPercentageOff: rewardSelected.percentageOff,
                    isPromoFinanceSelected: true,
                };
            }
        }
        if (this.state.isRewardOptionSelected) {
            payload = {
                specialDiscountApplied: true,
                params: {
                    data: [
                        {
                            optionType: REWARD_OPTION_TYPE,
                            promoFinance: null,
                        },
                    ],
                },
            };
        }
        if (!isEmpty(payload)) {
            this.props.actions.postSelectedRewardOrFinancingOffers(payload);
            this.setState({ isModalOpen: false });
        }
        document.body.style.overflow = 'scroll';
        document.body.style.position = 'static';
    }

    getRewardSelected = (orderDetails) => {
        const adjustments = get(orderDetails, 'data.adjustments', []);
        const reward = find(adjustments, { rewardCategory: REWARD_CATEGORY });
        return !isEmpty(reward) ? reward : {};
    };

    /* istanbul ignore next */
    renderModalContent() {
        const { orderDetails, orderInfo, currency } = this.props;
        const offerReward = this.getRewardSelected(orderDetails);
        const financeOptions = orderInfo.financing;
        const financingTermsText =
            financeOptions.description && financeOptions.description.split('$');
        if (offerReward && offerReward.percentageOff) {
            offerReward.percentageOff = getFormattedValue(offerReward.percentageOff);
        }
        return (
            <div
                data-automation-id="at-promo-financing-decision-block"
                className={`${cx('financingOrRewardsBody')} ${dt([' w-3/4', 'mx-auto', 'my-0'])}`}
            >
                <div
                    className={`${cx('keepFinancingWrapper')} ${dt([
                        'flex',
                        'flex-row',
                        'mt-0',
                        'mx-0',
                        'mb-5',
                    ])}`}
                >
                    <RadioButton
                        inputKey="financingDecisionRadioButton"
                        id="financing-radioButton"
                        type="Default"
                        name="decisionRadioButton"
                        defaultChecked
                        automationId="at-finance-decision-radio"
                        className={`${cx('financingRadioLabel')} ${dt([
                            'before:absolute',
                            'before:top-1/2',
                            'before:-translate-y-1/2',
                            'before:inline-block',
                        ])}`}
                        onClick={() => {
                            this.handleFinancingOfferSelection(financeOptions);
                        }}
                    />
                    <div className={dt(['flex', 'flex-col'])}>
                        <div className={dt(['leading-[1.71]', 'inline'])}>
                            Keep Special Financing
                            <div
                                className={dt([
                                    'smOnly:block',
                                    'md:inline',
                                    'font-open-sans-bold',
                                    'text-success-border',
                                ])}
                            >
                                {' '}
                                (Already applied)
                            </div>
                        </div>
                        <div className={`${dt(['font-open-sans-bold'])} ${cx('financeTerms')}`}>
                            {financingTermsText[0]}.{' '}
                            <span className={dt(['font-open-sans-regular', 'text-black'])}>
                                ${financingTermsText[1] || ''}
                            </span>
                        </div>
                    </div>
                </div>
                <div
                    className={`${cx('rewardsSeperator')} ${dt([
                        'overflow-visible',
                        'text-center',
                        'leading-[1px]',
                        'border-t',
                        'border-solid',
                        'border-gray-15',
                        'my-8',
                        'mx-0',
                    ])}`}
                >
                    <span
                        className={dt([
                            'p-1',
                            'relative',
                            'text-black',
                            'bg-white',
                            'font-open-sans-bold',
                        ])}
                    >
                        OR
                    </span>
                </div>
                <div className={dt(['flex', 'flex-row'])}>
                    <RadioButton
                        inputKey="financingDecisionRadioButton"
                        id="rewards-radioButton"
                        type="Default"
                        name="decisionRadioButton"
                        automationId="at-rewards-decision-radio"
                        className={cx('rewardsRadioLabel')}
                        onClick={this.handleSpecialDiscountSelection}
                    />
                    <div className={dt(['flex-col', 'flex'])}>
                        <div className={dt(['leading-7', 'inline'])}>
                            Use {offerReward.percentageOff}% &nbsp;Off Discount -
                            <div
                                className={dt([
                                    'inline',
                                    'font-open-sans-bold',
                                    'text-success-border',
                                ])}
                            >
                                {' '}
                                Save{' '}
                                {currencyFormatter.format(offerReward.amount, {
                                    code: currency,
                                    precision: 2,
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { orderDetails } = this.props;
        const offerReward = this.getRewardSelected(orderDetails);
        return (
            <ModalBox
                showModal={this.state.isModalOpen}
                defaultCloseBtn={false}
                defaultHeader
                automationId="at-promo-financing-decision-modal"
                deviceType={this.props.deviceType}
                titleAutomationId="at-promo-financing-decision-title"
                title={`${offerReward.percentageOff}% ${REWARD_OR_PROMO_FINANCING_TITLE}`}
                subTitle={`${REWARD_OR_SPECIAL_FINACING_DESC.SENTENCE1} ${offerReward.percentageOff}%
                ${REWARD_OR_SPECIAL_FINACING_DESC.SENTENCE2}`}
                subTitleAutomationId="at-promo-financing-decision-body"
                ctaBtns={[
                    {
                        title: CONTINUE,
                        automationId: 'at-accept-and-continue',
                        buttonType: 'Primary',
                        size: 'Md',
                        onClickAction: this.handleContinueClick,
                    },
                ]}
            >
                {this.renderModalContent()}
            </ModalBox>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...actions, ...cartActions, ...openModelEvent }, dispatch),
});

const mapStateToProps = ({ orderPaymentInfo, orderDetails, context, orderInfo, payment }) => ({
    orderPaymentInfo,
    orderDetails,
    orderInfo,
    payment,
    messagesTexts: context.messagesTexts,
    preferences: context.preferences,
    deviceType: context.deviceType,
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoFinanceDecisionModal);
